import { render, staticRenderFns } from "./Knowledge_check.vue?vue&type=template&id=2a1899a1"
import script from "./Knowledge_check.vue?vue&type=script&lang=js"
export * from "./Knowledge_check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports